import { render } from "./defeatRecord.vue?vue&type=template&id=7cdd8372&ts=true"
import script from "./defeatRecord.vue?vue&type=script&lang=ts"
export * from "./defeatRecord.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__